/**
 * راهنمای برنامه (v2.146.0) — کاربر (۱۴۰۵/۰۷/۱۳): «آموزشِ استفاده از برنامه؛ برای هر بخش یک علامتِ سؤال که دقیق توضیح بدهد،
 * با عکس/اسکرین‌شات، مراحلِ ورودِ اطلاعات دقیق در هر صفحه، و سؤالاتِ پرتکرار؛ برای تمامِ بخش‌ها به ترتیب تا تنظیمات».
 *
 * هر راهنما: id، group، title، paths (کدام صفحه/تب این راهنما را باز می‌کند)، imgs (public/guide-img/<name>.jpg)،
 * summary، steps (مراحل)، fields ([نام، توضیح])، faq ([سؤال، جواب])، tips.
 * عکس‌ها با `tools/guide-screenshots.mjs` از نسخهٔ محلی گرفته می‌شوند و داده‌ها (نام/مبلغ) در آن‌ها تار است.
 * صفحهٔ تازه اضافه شد؟ همین‌جا راهنمایش را بنویس و در `GUIDE_GROUPS` بگذار.
 */

export const GUIDE_GROUPS = [
  { id: "start", title: "شروع کار" },
  { id: "production", title: "تولید و بسته‌بندی" },
  { id: "personnel", title: "پرسنل" },
  { id: "payroll", title: "محاسبهٔ حقوق" },
  { id: "accounting", title: "حساب و کتاب" },
  { id: "supply", title: "زنجیره تأمین" },
  { id: "assets", title: "اموال" },
  { id: "dye", title: "پیگیری رنگرزی" },
  { id: "other", title: "گفتگو و مدیریت" },
  { id: "settings", title: "تنظیمات" },
];

const G = [];
const add = (g) => G.push(g);

/* ───────────────────────────── شروع کار ───────────────────────────── */
add({
  id: "basics", group: "start", title: "آشنایی با برنامه و کار با لیست‌ها", paths: ["/guide"],
  imgs: ["dashboard"],
  summary: "برنامه از منوی سمتِ راست باز می‌شود: «تولید» (برش، دوخت، کنترل، پرسنل، حضور و حقوق)، «حساب و کتاب»، «زنجیره تأمین»، «گفتگو» و «تنظیمات». هر صفحه یک دکمهٔ «؟» در نوارِ بالا دارد که همین راهنما را برای همان صفحه باز می‌کند.",
  steps: [
    "با نام کاربری و رمزِ خودتان وارد شوید. هر کاربر فقط بخش‌هایی را می‌بیند که مدیر به او دسترسی داده است.",
    "از منوی راست بخشِ موردنظر را باز کنید. روی گوشی منو با دکمهٔ ☰ بالای صفحه باز می‌شود.",
    "ماهِ کاری را یک‌بار انتخاب کنید؛ بقیهٔ صفحه‌ها (حقوق، بیمه، حضور، پرداخت حقوق، گزارش‌ها) با همان ماه باز می‌شوند.",
    "هر جا گیر کردید، دکمهٔ «؟» بالای صفحه را بزنید.",
  ],
  fields: [
    ["جدول‌ها (لیست‌ها)", "روی سرستون بزنید تا مرتب شود (بالا/پایین)؛ آیکونِ ذره‌بین/قیف کنارِ سرستون جست‌وجو و فیلترِ همان ستون است. «ستون‌ها» ستون‌های اضافه را خاموش/روشن می‌کند و «خروجی» اکسل می‌دهد. عرض و ترتیبِ ستون‌ها با کشیدن عوض می‌شود و برای خودتان یادش می‌ماند."],
    ["بزرگ‌نمایی جدول", "پایینِ هر لیست نوارِ ٪ هست (مثلِ اکسل): − و + یا Ctrl + چرخِ ماوس. کلیک روی درصد = ۱۰۰٪."],
    ["پیش‌نویسِ خودکار", "برگه‌های تولید (برش، دوخت، ضایعات) هنگامِ تایپ خودکار ذخیره می‌شوند. اگر صفحه بسته شد یا بروزرسانی آمد، نوارِ زردِ «ادامه» همان اطلاعات را برمی‌گرداند."],
    ["اعلانِ بروزرسانی", "وقتی نسخهٔ جدید آماده است، گوشهٔ صفحه اعلان می‌آید: «همین حالا» یا «عقب بینداز». بعد از نصب یک‌بار صفحه را رفرش کنید."],
    ["حالتِ تیره/روشن", "دکمهٔ لامپ در نوارِ بالا."],
  ],
  faq: [
    ["چرا یک بخش را در منو نمی‌بینم؟", "دسترسیِ آن بخش برای کاربرِ شما فعال نیست. مدیر از «تنظیمات ← کاربران» نقش یا تیکِ مجوز را برایتان باز می‌کند."],
    ["بعد از بروزرسانی صفحه عوض نشد", "یک‌بار صفحه را رفرش کنید؛ اگر باز قدیمی بود Ctrl+Shift+R (در مک Cmd+Shift+R)."],
    ["چرا مرا از برنامه بیرون انداخت؟", "مدتِ نشستِ کاربرِ شما تمام شده (مدیر برای هر کاربر تعیین می‌کند، مثلاً هر ۱۲ ساعت). دوباره وارد شوید."],
    ["چیدمانِ جدول به‌هم ریخته، چطور برگردانم؟", "«تنظیمات ← ظاهر ← بازگرداندنِ چیدمانِ جدول‌ها»."],
  ],
});
add({
  id: "dashboard", group: "start", title: "داشبورد", paths: ["/dashboard", "/"], imgs: ["dashboard"],
  summary: "نمای کلیِ امروز: پرسنلِ فعال، عملیاتِ ثبت‌شدهٔ امروز، سفارش‌های در جریان، وضعیتِ دورهٔ حقوقِ جاری، جمعِ خالص و مساعده‌ها و هشدارهای حقوقِ منفی.",
  steps: [
    "کارت‌ها را از بالا بخوانید؛ هر کارتی که «مشاهدهٔ کامل ›» دارد شما را به همان صفحه می‌برد.",
    "«تازه‌سازی» اعداد را از نو می‌خواند.",
  ],
  faq: [
    ["عددِ داشبورد با صفحهٔ حقوق نمی‌خواند", "داشبورد دورهٔ جاری را نشان می‌دهد؛ اگر در صفحهٔ حقوق ماهِ دیگری باز است، یا «محاسبهٔ مجدد» نزده‌اید، اعداد فرق می‌کند."],
  ],
});

/* ───────────────────────────── تولید ───────────────────────────── */
add({
  id: "cut", group: "production", title: "ثبت برش (بیجک)", paths: ["/production/cut"], imgs: ["cut"],
  summary: "شروعِ زنجیرهٔ تولید: هر برگهٔ بیجکِ برش اینجا ثبت می‌شود. «کد تولید» روی محصول است و همهٔ مراحلِ بعد (دوخت، کنترل، ضایعات) با آن پیدا می‌شوند؛ «شماره بیجک» شمارهٔ برگهٔ سند است. حقوقِ برشکار هم از همین ثبت ساخته می‌شود.",
  steps: [
    "«بیجک جدید» را بزنید تا فرم خالی شود.",
    "«شماره بیجک» بالای فرم را بنویسید — این شماره پیش‌فرضِ همهٔ ردیف‌هاست.",
    "«کد تولید» را بنویسید یا خالی بگذارید تا خودکار ساخته شود (قانون: ماه + روز).",
    "«تاریخ برش»، «برشکار» و اگر حقوقش مالِ ماهِ دیگری است «ماه محاسبه» را انتخاب کنید.",
    "در «ردیف‌های محصول» برای هر سایز یک ردیف: شماره بیجک (اگر این محصول در برگهٔ دیگری نوشته شده، شمارهٔ همان برگه؛ خالی = شمارهٔ بالا)، محصول، مدل (اختیاری)، رنگ، سایز، «جین» و «تکی اضافه». تعداد خودکار = جین × ۱۲ + تکی.",
    "برای سایزِ بعدی «تکرار ردیف» یا «افزودن ردیف» را بزنید.",
    "«ثبت» را بزنید. بیجک در «بیجک‌های ثبت‌شده» پایینِ صفحه می‌آید و حقوقِ برشکار (فی ۱۲۷٬۵۰۰ ریال برای هر جین) در «کارکرد و حقوق برشکار» ساخته می‌شود.",
  ],
  fields: [
    ["شماره بیجک", "شمارهٔ برگهٔ کاغذی. یک شماره فقط زیرِ یک کدِ تولید می‌تواند باشد. هر محصول می‌تواند شمارهٔ خودش را داشته باشد (یک کدِ تولید با چند برگه)."],
    ["کد تولید", "شناسهٔ محصول در کلِ کارخانه؛ چند محصول/سایز زیرِ یک کد. تا وقتی کارِ دوخت/کنترل روی آن ثبت نشده قابلِ اصلاح است («اصلاحِ کد»)."],
    ["ماه محاسبه", "خالی = طبقِ تاریخِ برش. اگر برش خرداد بوده ولی حقوقش تیر حساب می‌شود، تیر را بزنید."],
    ["مدل", "فقط وقتی یک ردیفِ نرخ‌نامه چند محصولِ هم‌نرخ دارد (مثلاً «رکابی و تاپ»)."],
  ],
  faq: [
    ["می‌گوید «شماره بیجک تکراری است»", "این شماره قبلاً زیرِ کدِ تولیدِ دیگری ثبت شده. اگر همان بیجک است «رفتن به همان بیجک» را بزنید؛ اگر برگهٔ جدید است شمارهٔ درست را بنویسید."],
    ["یک کدِ تولید محصولاتِ زیادی دارد و در چند برگهٔ بیجک نوشته شده", "در ستونِ «شماره بیجک» هر ردیف، شمارهٔ برگهٔ همان محصول را بنویسید. سایزهای یک محصول باید یک شماره داشته باشند."],
    ["محصول را از بیجک حذف می‌کنم ولی نمی‌شود", "روی آن دوخت/کنترل ثبت شده؛ اول در «ثبت و مدیریت تولید» دوختِ همان سایز را پاک کنید، بعد حذف کنید."],
    ["حقوقِ برشکار کجاست؟", "پایینِ همین صفحه «کارکرد و حقوق برشکار»؛ در فیشِ برشکار تعدادِ جین و فیِ هر جین چاپ می‌شود."],
    ["وسطِ ثبت صفحه بسته شد", "دوباره که این صفحه را باز کنید نوارِ زردِ «پیش‌نویس… ادامه» می‌آید."],
  ],
});
add({
  id: "waste", group: "production", title: "ثبت ضایعات", paths: ["/production/waste"], imgs: ["waste"],
  summary: "تعدادِ قطعه‌هایی که در برش، دوخت یا کنترل نهایی از بین رفته. فقط برای مغایرت‌گیریِ تعدادِ برش با کنترل‌هاست و روی حقوق و کارکرد اثری ندارد.",
  steps: [
    "«کد تولید» را انتخاب کنید؛ محصول/رنگ و سایز از همان بیجک پیشنهاد می‌شود.",
    "«مرحله» (برش / دوخت / کنترل نهایی)، «نوع ضایعات» و «تعداد» را بزنید.",
    "در صورتِ لزوم «پرسنل مرتبط»، «تاریخ» و «توضیح» را پر کنید و «ثبت ضایعات» را بزنید.",
  ],
  faq: [["ضایعات از حقوقِ کسی کم می‌شود؟", "خیر؛ فقط در مقایسهٔ «بیجک برش ← کنترل اول ← کنترل نهایی» دیده می‌شود."]],
});
add({
  id: "production", group: "production", title: "ثبت و مدیریت تولید (دوخت و کنترل)", paths: ["/production"],
  imgs: ["production", "production-drawer"],
  summary: "قلبِ تولید: لیستِ همهٔ محصولات با سه عددِ اصلی (بیجک برش، کنترل اول، کنترل نهایی) و اختلاف‌ها. با کلیک روی هر محصول، کشوی همان بیجک باز می‌شود و دوخت (کارکردِ کارگران)، کنترل اول، کنترل نهایی و ضایعات همان‌جا ثبت می‌شوند.",
  steps: [
    "در لیست، محصول را با جست‌وجو یا فیلترِ وضعیت (آماده دوخت، در حال دوخت، کنترل اول، کنترل نهایی…) پیدا کنید و روی «کد تولید» بزنید.",
    "در کشو، تبِ «عملیات و کارکرد / کنترل اول» را باز کنید و سایز را انتخاب کنید (هر سایز صفحهٔ جدا دارد).",
    "در برگهٔ ثبتِ کارکرد: هر ردیف یک «تعداد» دارد و در هر ستونِ عملیات (مثلاً «سرزانو»، «کش کمر») کارگرِ همان کار را انتخاب کنید. یک ردیف = همان تعداد برای همهٔ کارگرانِ آن ردیف.",
    "«ثبت» را بزنید. کارکرد فوراً در حقوقِ کارمزدیِ آن کارگران (در ماهِ محاسبهٔ همان سایز) می‌نشیند.",
    "وقتی دوختِ سایز تمام شد، «کنترل اول» را با تعداد ثبت کنید؛ از این لحظه دوختِ آن سایز قفل می‌شود.",
    "در پایان «کنترل نهایی» (سالم + زده‌دار) را ثبت کنید.",
  ],
  fields: [
    ["وضعیت", "آماده دوخت (برش دارد، دوخت ندارد) ← در حال دوخت ← کنترل اول (دوخت قفل) ← کنترل نهایی (تمام)."],
    ["ماه محاسبهٔ حقوقِ این پارت", "کارکردِ دوختِ این سایز در حقوقِ کدام ماه حساب شود."],
    ["اختلاف کنترل اول / نهایی", "تفاوتِ تعدادِ کنترل با تعدادِ برش؛ قرمز یعنی کم‌آمده."],
    ["پاک‌کردنِ کلِ دوختِ این سایز", "همهٔ کارکردهای این سایز (و اگر بخواهید کلِ محصول) پاک می‌شود — برای ثبتِ دوباره."],
    ["بستنِ تولیدِ ماه", "بعد از تمام شدنِ کارِ ماه، ماه را می‌بندد تا ثبتِ تازه روی آن نرود (با کدِ مدیریتی باز می‌شود)."],
  ],
  faq: [
    ["کارکرد را ثبت کردم ولی در فیش نیامد", "ماهِ محاسبهٔ همان سایز را ببینید؛ اگر ماهِ حقوق بسته شده، در ماهِ بعد بیاید. بعد در «محاسبه و بستن حقوق» برای آن نفر «محاسبهٔ مجدد» بزنید."],
    ["می‌گوید دوخت قفل است", "کنترلِ اولِ این سایز ثبت شده. برای اصلاح، «باز کردن برای اصلاح» را بزنید (ممکن است کدِ مدیریتی بخواهد)."],
    ["کنترل اول ثبت نمی‌شود", "تا برای آن سایز دوخت ثبت نشده، کنترل اول ممکن نیست."],
    ["این سایز «بدونِ برش» نوشته", "دوخت دارد ولی در بیجکِ برش نیست؛ «افزودن به بیجک» را بزنید تا اعداد درست شوند."],
    ["اشتباه ثبت کردم", "«ویرایش در برگهٔ ورود» همان برگه را با همان چیدمان باز می‌کند؛ اصلاح و دوباره ثبت کنید."],
  ],
  tips: ["برگهٔ نیمه‌کاره خودکار پیش‌نویس می‌شود؛ اگر پیش‌نویس در سایزِ دیگری باشد، بالای کشو دکمهٔ «برو به سایزِ X» می‌آید."],
});
add({
  id: "piece-rate", group: "production", title: "نرخ‌نامهٔ دوخت", paths: ["/piece-rate"], imgs: ["piece-rate"],
  summary: "فیِ هر عملیاتِ دوخت برای هر محصول (ریال). حقوقِ کارمزدی از تعدادِ کارکرد × همین فی حساب می‌شود.",
  steps: [
    "برای افزودنِ یک عملیات «افزودن عملیات» را بزنید: محصول، نامِ عملیات، تعدادِ خط، فی (ریال) و از تاریخ.",
    "برای ورودِ یک‌جا «ایمپورت نرخنامه جدید» را بزنید؛ پیش‌نمایش می‌آید و تا تأیید نکنید چیزی ذخیره نمی‌شود.",
    "اگر نرخ‌ها اشتباهاً تومانی وارد شده، «اصلاح تومان → ریال» را بزنید؛ اول پیش‌نمایش، بعد اصلاح.",
  ],
  faq: [["تغییرِ فی روی کارکردهای قبلی اثر دارد؟", "خیر؛ فیِ هر کارکرد در لحظهٔ ثبت ذخیره می‌شود. نرخِ جدید از «از تاریخ» به بعد."]],
});

/* ───────────────────────────── پرسنل ───────────────────────────── */
add({
  id: "employees", group: "personnel", title: "لیست پرسنل", paths: ["/employees"], imgs: ["employees"],
  summary: "پروندهٔ هر نفر: مشخصاتِ هویتی و تماس، اطلاعاتِ حقوقی (نوعِ حقوق: ثابت/روزمزد/کارمزدی، پایه، بیمه)، اطلاعاتِ بانکی (شبا، کارت، صاحبِ حساب) و نوعِ همکاری.",
  steps: [
    "«پرسنل جدید» را بزنید (یا «ویرایش» روی یک نفر).",
    "تبِ «اطلاعات پرسنلی»: نام، کد پرسنلی، بخش، سمت، تاریخ ورود.",
    "تبِ «هویتی و تماس»: کد ملی، تلفن، ملیت (ایرانی/افغانستانی).",
    "تبِ «اطلاعات حقوقی»: نوعِ حقوق، حقوقِ پایه/نرخِ روزانه، بیمه‌ای بودن، مشمولِ حضور و غیاب، «کارمزد حساب شود».",
    "تبِ «اطلاعات بانکی»: صاحبِ حساب، شبا، کارت — همین در فایل‌های پرداخت می‌آید.",
    "«نقش‌ها و بازه‌های حقوقی» برای وقتی است که کسی از یک تاریخ مدلش عوض می‌شود (مثلاً از ۱۵ تیر روزمزد) یا نقشِ اضافه دارد (سرایداری).",
  ],
  fields: [
    ["خارج از محاسبه حقوق", "تیک بخورد ⇒ نه حقوق، نه در لیست‌های پرداخت، اسنادِ مالی و ماندهٔ حساب دیده می‌شود تا تیک برداشته شود."],
    ["غیرفعال", "پرسنلِ رفته؛ از لیست‌ها کنار می‌رود ولی سابقه‌اش می‌ماند. با تیکِ «غیرفعال‌ها هم نشان داده شود» دیده می‌شود."],
    ["راننده", "در «نوع همکاری» تیک بخورد تا در «راننده‌ها و مأموریت‌ها» بیاید."],
  ],
  faq: [
    ["یک نفر دو بار ثبت شده", "«پیداکردن و یکی‌کردنِ پرونده‌های تکراری» را بزنید."],
    ["فرمِ ثبت‌نام برای پرکردنِ دستی", "«فرمِ ثبت‌نامِ خام (A4)»؛ برای فرمِ پرشده «فرم مشخصات و ثبت‌نام (PDF)»."],
    ["شبا را عوض کردم، در فایلِ پرداخت آمد؟", "بله؛ لیست‌های پرداخت اطلاعاتِ بانکی را زنده از پرونده می‌خوانند."],
  ],
});
add({
  id: "departments", group: "personnel", title: "بخش‌ها / واحدها", paths: ["/departments"], imgs: ["departments"],
  summary: "واحدهای کارخانه (برش، دوخت، کنترل، بسته‌بندی، اداری…). هر پرسنل به یک بخش وصل است.",
  steps: ["«بخش جدید» را بزنید، نام را بنویسید و ذخیره کنید.", "برای شروع سریع «ثبت بخش‌های پیش‌فرض»."],
});
add({
  id: "employee-import", group: "personnel", title: "ورود پرسنل از اکسل", paths: ["/employee-import"], imgs: ["employee-import"],
  summary: "ثبت یا به‌روزرسانیِ یک‌جای پرسنل از فایلِ اکسل.",
  steps: [
    "فایل را انتخاب کنید؛ «پیش‌نمایش» ردیف‌ها را با وضعیتِ هرکدام نشان می‌دهد.",
    "ردیف‌هایی را که نباید وارد شوند با «این ردیف وارد نشود» کنار بگذارید.",
    "«تأیید» را بزنید. تا تأیید نکنید چیزی ذخیره نمی‌شود.",
  ],
  faq: [["ردیفِ هم‌نام رد شد", "برای نفراتِ هم‌نام کد ملی لازم است؛ در فایل یا در صفحهٔ پرسنل تکمیل کنید."]],
});

/* ───────────────────────────── محاسبهٔ حقوق ───────────────────────────── */
add({
  id: "attendance", group: "payroll", title: "حضور و غیاب", paths: ["/attendance"], imgs: ["attendance"],
  summary: "ترددهای دستگاه (کارت/انگشت) اینجا وارد و به روزهای کاری تبدیل می‌شوند: حضور، غیبت، کسرکار و اضافه‌کاری. حقوقِ ماه تا وقتی حضورِ همان ماه «نهایی» نشده محاسبه نمی‌شود.",
  steps: [
    "تبِ «بارگذاری فایل»: فایلِ خروجیِ دستگاه (مثل GLG_001.TXT یا DAT) را بدهید. کدِ کارت و نامِ هر نفر از خودِ دستگاه خوانده می‌شود.",
    "اگر کسی «ناشناس» ماند (کارتش به پرسنلی وصل نیست)، در «ثبت‌های خام دستگاه» با «نگاشت به پرسنل» او را وصل کنید.",
    "تبِ «خلاصهٔ ماهانه»: روی نامِ هر نفر بزنید تا کاردکسِ ماهش باز شود. سبز = سالم، نارنجی = نیازمند بررسی، قرمز = غیبتِ حل‌نشده.",
    "روزهای نارنجی/قرمز را بررسی کنید: «بخشش»، اصلاحِ ساعت، یا ثبتِ مرخصی.",
    "برای روزی که دستگاه خراب بود یا کارگاه زودتر تعطیل شد، به‌جای بخششِ تک‌تک، از «اصلاحِ همگانیِ ساعتِ یک روز» استفاده کنید.",
    "اگر برای کسی دستگاه معیار نیست، «ثبتِ دستیِ حضورِ ماه»: حضور (روز)، غیبت (روز)، کسرکار و اضافه‌کاری (دقیقه).",
    "وقتی همه بررسی شد «نهایی‌سازی» را بزنید. حالا حقوقِ ماه قابلِ محاسبه است.",
  ],
  fields: [
    ["ثبتِ خام", "هر بار کارت زدن یک ثبتِ خام است؛ برنامه آن‌ها را به ورود/خروجِ روز تبدیل می‌کند."],
    ["کسرکار / اضافه‌کاری", "با پنجرهٔ حضورِ هر روز (تنظیمات ← ساعت کاری) و نرخِ روزانهٔ همان نفر حساب می‌شود."],
    ["گریدِ هفتگی", "ویرایشِ انبوهِ ساعت‌ها در یک هفته."],
  ],
  faq: [
    ["ماه نهایی شده ولی باید یک روز را اصلاح کنم", "ویرایش در ماهِ نهایی کدِ مدیریتی می‌خواهد؛ یا درخواستِ اصلاح بفرستید تا مدیر در «گفتگو» تأیید کند."],
    ["کسی کارت زده ولی در پرسنل نیست", "در «ثبت‌های خام» زیرِ «ناشناس‌ها» می‌آید؛ ترددش حفظ شده و با «نگاشت به پرسنل» وصل می‌شود."],
    ["پرسنلِ کارمزدی کسرکار دارد؟", "اگر «مشمولِ حضور و غیاب» نباشد، حقوقش فقط از کارکردِ تولید می‌آید."],
  ],
});
add({
  id: "payroll", group: "payroll", title: "محاسبه و بستن حقوق", paths: ["/payroll"], imgs: ["payroll", "payroll-edit"],
  summary: "حقوقِ هر ماه اینجا ساخته، بررسی و بسته می‌شود: از حضور، کارکردِ تولید، رانندگی، بیمه و اسنادِ مالیِ همان ماه (مساعده، خرید، جریمه…) و «ماندهٔ قبلی». بعد از تأییدِ نهایی، طلبِ هر نفر خودکار در دفترِ مالی می‌نشیند و پرداخت‌ها از «پرداخت حقوق» انجام می‌شود.",
  steps: [
    "اگر ماه در جدولِ «دوره‌های حقوقی» نیست، «دوره جدید» را بزنید و سال/ماه را انتخاب کنید.",
    "اول حضور و غیابِ همان ماه را نهایی کنید (صفحهٔ حضور).",
    "روی «محاسبه» (یا «محاسبه مجدد») بزنید. لیستِ حقوق با همهٔ مؤلفه‌ها ساخته می‌شود.",
    "«مشاهده» را بزنید و لیست را بررسی کنید. حقوقِ منفی‌ها بالای لیست هشدار می‌گیرند.",
    "برای اصلاحِ یک نفر روی ✏️ بزنید: «ردیف‌های اصلاحی» (عملیاتِ کارمزدیِ جامانده، روزمزد، ساعتی، مبلغ) یا «ویرایش دستی مبالغ». بالای پنجره «قبلی/بعدی» بینِ نفرات می‌رود.",
    "فیشِ هر نفر را با «فیش PDF» ببینید (A4 یا A5).",
    "مراحلِ بستن: «تأیید حسابداری» ← «تأیید مدیریت» ← «قفل نهایی». با تأیید، حقوقِ هر نفر به‌عنوانِ طلب در حسابش ثبت می‌شود.",
    "بعد از بستن، پرداخت‌ها را از «حساب و کتاب ← پرداخت حقوق» ثبت کنید؛ لازم نیست ماه را باز کنید.",
  ],
  fields: [
    ["مانده از قبل", "ماندهٔ حسابِ شخص تا پیش از این ماه: بدهی (کسر) یا بستانکاری (اضافه). حقوقِ ماهِ قبل که در لیستِ پرداختِ همان ماه پرداخت می‌شود اینجا نمی‌آید."],
    ["پرداختی بیمه", "پرداختِ بانکِ رسمی؛ جزوِ پرداخت‌هاست، کسر نیست."],
    ["ردیف‌های اصلاحی", "فقط برای محاسبهٔ همین ماه؛ با «محاسبهٔ مجدد» نمی‌پرند. همین ردیف‌ها از «اسناد مالی ← قلمِ حقوقی» هم ساخته می‌شوند."],
    ["رکوردِ دستی", "اگر مبالغ را دستی ویرایش کنید، «محاسبهٔ مجدد» آن را بازنویسی نمی‌کند مگر «بازنویسی» را تأیید کنید."],
    ["انتقال بدهی به ماه بعد", "اگر کسورات بیش از حقوق است، بخشی را به ماهِ بعد بفرستید (مثلِ وامِ کوتاه‌مدت)."],
  ],
  faq: [
    ["سندی در اسناد مالی زدم، باید دوباره محاسبه کنم؟", "خیر؛ ثبت/ویرایش/حذفِ سند، پرداخت یا انتقال، حقوقِ همان نفر را در ماهِ باز خودکار دوباره حساب می‌کند."],
    ["«مانده از قبل» عجیب است", "روی ردیف بزنید تا ریزش (بدهی‌ها، مساعده‌ها، پرداخت‌های بعد از پایانِ ماه) را ببینید. اگر ماهِ قبل هنوز بسته نشده، مانده نمی‌آید."],
    ["ماه را بستم ولی باید اصلاح کنم", "«بازگشاییِ ماه (کد مدیریتی)». با بازگشایی، طلب‌های ثبت‌شده از دفتر برداشته و با بستنِ دوباره از نو ثبت می‌شوند."],
    ["کسی حقوقِ منفی دارد", "یعنی کسوراتش بیش از حقوق است؛ یا بخشی را به ماهِ بعد منتقل کنید یا بگذارید هنگامِ بستن بدهیِ ماهِ بعدش شود."],
    ["«محاسبهٔ اجباری» چیست؟", "محاسبه بدونِ نهایی‌بودنِ حضور — فقط برای دیدنِ پیش‌نویس؛ قبل از بستن حضور را نهایی کنید."],
  ],
});
add({
  id: "insurance", group: "payroll", title: "بیمه (دو مرحله)", paths: ["/insurance"], imgs: ["insurance"],
  summary: "مرحلهٔ ۱: «حق بیمه» (سهمِ کارمند) که از حقوق کسر می‌شود. مرحلهٔ ۲: «پرداختی از بانکِ رسمی» که جزوِ پرداختِ حقوق است، نه کسر — خودکار در «پرداخت حقوق» به نامِ «بیمه — بانکِ رسمی» ثبت و از ماندهٔ پرداختِ هر نفر کم می‌شود.",
  steps: [
    "ماه را انتخاب کنید.",
    "تبِ «۱) حق بیمه»: «بارگذاری فایل بیمه» (لیستِ بیمه) یا «افزودن دستی». پیش‌نمایش را ببینید و تأیید کنید.",
    "ستونِ «پرسنلِ تطبیق‌یافته» را برای ردیف‌های تطبیق‌نیافته درست کنید تا مبلغ در فیش اعمال شود.",
    "اگر حق بیمه را عوض کردید، حقوقِ ماه را «محاسبهٔ مجدد» کنید.",
    "تبِ «۲) پرداختیِ بیمه»: فایلِ پرداختِ بانکِ رسمی را بدهید و «ثبت به‌عنوانِ پرداختی (مرحلهٔ ۲)» را بزنید. حقوقِ دوره بسته می‌ماند و محاسبهٔ مجدد لازم نیست.",
  ],
  faq: [
    ["فایل را نمی‌پذیرد: «ماهِ فایل با ماهِ انتخاب‌شده نمی‌خواند»", "ماهِ بالای صفحه را با ماهِ فایل یکی کنید."],
    ["«این فایل احتمالاً فایلِ پرداختی است»", "فایلِ پرداخت را در تبِ ۲ بدهید، نه ۱."],
    ["پرداختِ بیمهٔ یک نفر اشتباه است", "در «پرداخت حقوق» روی «ویرایش» همان نفر بزنید؛ پرداختِ بیمه ویرایش/حذف می‌شود و «اصلاحِ دستی» می‌خورد تا ایمپورتِ بعدی برش نگرداند."],
  ],
});
add({
  id: "drivers", group: "payroll", title: "راننده‌ها و مأموریت‌ها", paths: ["/drivers"], imgs: ["drivers"],
  summary: "حقوقِ رانندهٔ کارمزدی = نرخِ هر مأموریت × تعدادِ دفعاتِ ماه.",
  steps: [
    "در «نرخ مأموریت‌ها» هر مأموریت (مثلاً «قرچک ← تهران») را با نرخ (ریال) تعریف کنید.",
    "در «ثبت ماهانهٔ مأموریت»: راننده، مأموریت و تعداد را بزنید.",
    "جمعِ دوره بالای صفحه می‌آید و در حقوقِ همان ماه حساب می‌شود.",
  ],
  faq: [["راننده در لیست نیست", "در «لیست پرسنل ← نوع همکاری» تیکِ «راننده» را بزنید."]],
});

/* ───────────────────────────── حساب و کتاب ───────────────────────────── */
add({
  id: "fin-balances", group: "accounting", title: "مانده و وضعیت حساب", paths: ["/finance?tab=balances"], imgs: ["fin-balances"],
  summary: "ماندهٔ همین لحظهٔ حسابِ هر نفر. بدهکار = پرسنل به کارخانه بدهکار است؛ بستانکار = کارخانه به او. ترتیب: بدهکارها (بزرگ‌ترین بالا)، بستانکارها، و آخر تسویه‌شده‌ها.",
  steps: [
    "با «همه / بدهکار / بستانکار / تسویه» و جست‌وجوی نام فیلتر کنید.",
    "برای ماندهٔ یک تاریخِ خاص «تا تاریخ» را پر کنید.",
    "روی نامِ هر نفر بزنید تا «دفتر حساب شخص» با ریزِ اسناد باز شود.",
    "«ثبت پرداخت» کنارِ هر نفر یک سندِ پرداخت/دریافت برای همان نفر باز می‌کند.",
    "«لیستِ ساده ▾»: لیستِ بدهکاران، بستانکاران یا هر دو (نام + مبلغ، بیمه‌ای بالا/غیربیمه‌ای پایین) — در پیش‌نمایش A4 یا A5 را انتخاب کنید.",
  ],
  faq: [
    ["«جمع بدهکار − جمع بستانکار» با مانده نمی‌خواند", "همیشه می‌خواند؛ اگر نه، «بازخوانی» را بزنید. اسنادِ «در انتظارِ پرداخت» تا پرداخت نشوند در مانده نیستند."],
    ["کسی که «خارج از محاسبه حقوق» است کجاست؟", "تا تیکش برداشته نشود در هیچ لیستِ مالی نمی‌آید."],
  ],
});
add({
  id: "fin-payments", group: "accounting", title: "پرداخت حقوق", paths: ["/finance?tab=payments"], imgs: ["fin-payments"],
  summary: "بعد از بستنِ حقوقِ ماه، پرداخت‌ها اینجا ثبت می‌شود: برای هر نفر «قابلِ پرداخت»، «پرداخت‌شده»، انتقال‌ها و «مانده». پرداخت در محاسبهٔ حقوق کسر نمی‌شود؛ فقط حساب را صاف می‌کند.",
  steps: [
    "ماه را از بالا انتخاب کنید.",
    "پرداختِ یک نفر: «پرداخت» جلوی همان ردیف ← مبلغ (پیش‌فرض = مانده)، تاریخ، روش (بانکی/نقدی/چک)، شمارهٔ پیگیری و مبدأ (دفتر یا تنخواه).",
    "پرداختِ همه: «پرداختِ همه» برای کسانی که تیک خورده‌اند (یا همه) با ماندهٔ کامل.",
    "فایلِ بانک: «فایل‌ها ▾» ← «فایلِ پرداختِ بانک (کامل)» یا «لیستِ ساده»؛ بیمه‌ای و غیربیمه‌ای جدا. اگر تیک زده باشید فقط همان‌ها.",
    "اصلاح: «✏️ ویرایش» جلوی هر نفر همهٔ پرداخت‌هایش را با ویرایش/حذف نشان می‌دهد (پرداختِ بیمه هم).",
    "وقتی کارِ ماه تمام شد «🔒 بستنِ پرونده»: پرداخت‌نشده‌ها پاک نمی‌شوند و در «مانده و وضعیت حساب» طلبِ همان نفر می‌مانند.",
  ],
  fields: [
    ["وضعیت", "پرداخت نشده / نیمه‌پرداخت / تسویه شد / حقوق منفی / بدهکار."],
    ["انتقال", "پولی که از حقوقِ این نفر به حسابِ همکارش رفته (➡) یا از همکار به حسابش آمده (⬅). کلیک = ویرایش."],
    ["مبدأ", "دفتر یا تنخواه — تنخواه یعنی همان پرداخت خودکار در صندوق هم می‌نشیند."],
    ["ثبتِ دوبارهٔ حقوق در دفتر مالی", "ته منوی «فایل‌ها»؛ معمولاً لازم نیست (با تأییدِ نهایی خودکار ثبت می‌شود). فقط اگر حسابی جا افتاده."],
  ],
  faq: [
    ["پرداخت را اشتباه زدم", "«✏️ ویرایش» جلوی همان نفر ← ✏️ برای اصلاح یا 🗑 برای حذف. اگر پرونده بسته است، اول «بازگشایی» (کد مدیریتی)."],
    ["چرا دکمهٔ پرداخت نیست؟", "پروندهٔ پرداختِ ماه بسته شده یا مانده صفر است."],
    ["یک نفر را نمی‌خواهیم پرداخت کنیم و پرونده تمام شود", "«بستنِ پرونده» را بزنید؛ باقی‌مانده در حسابش می‌ماند و ماه‌های بعد دیده می‌شود."],
  ],
});
add({
  id: "fin-transfer", group: "accounting", title: "انتقال بین پرسنل", paths: [], imgs: ["fin-transfer"],
  summary: "پول از حسابِ یک نفر کم و به حسابِ نفرِ دیگر اضافه می‌شود — پولی جابه‌جا نمی‌شود، فقط حساب‌ها اصلاح می‌شوند. دکمه‌اش در «پرداخت حقوق» و «اسناد مالی» است.",
  steps: [
    "«انتقال بین پرسنل» را بزنید.",
    "۱) از حسابِ چه کسی کم شود؟ ۲) به حسابِ چه کسی اضافه شود؟ ۳) مبلغ (دکمهٔ «به اندازهٔ کلِ بدهیِ …» خودش پر می‌کند).",
    "۴) بابتِ حقوقِ کدام ماه؟ — انتقال در لیستِ پرداختِ همان ماه برای هر دو نفر نوشته می‌شود.",
    "جعبهٔ «نتیجهٔ این انتقال» حسابِ هر دو را قبل و بعد نشان می‌دهد؛ اگر درست است «ثبتِ انتقال».",
    "ویرایش/حذف: در فهرستِ پایینِ همان پنجره ✏️ یا 🗑 (هر دو طرف با هم برمی‌گردند).",
  ],
  faq: [
    ["خانواده: حقوقِ زهرا بدهیِ سمیرا را صاف کند", "از: زهرا، به: سمیرا، مبلغ: بدهیِ سمیرا، ماه: همان ماه."],
    ["یک چک به نامِ علی دادیم که حقوقِ رضا هم داخلش بود", "اول پرداختِ چک را برای علی ثبت کنید؛ بعد انتقال: از رضا، به علی، مبلغ: حقوقِ رضا."],
  ],
});
add({
  id: "fin-advances", group: "accounting", title: "مساعده (دسته‌جمعی)", paths: ["/finance?tab=advances"], imgs: ["fin-advances"],
  summary: "لیستِ مساعدهٔ چند نفر یک‌جا؛ تا «پرداخت شد» نخورد در حسابِ کسی نمی‌نشیند. مساعده در حقوقِ همان ماه کسر می‌شود.",
  steps: [
    "نفرات را از کادرِ بالا اضافه کنید و مبلغ هر نفر را بزنید.",
    "تاریخ، روش و مبدأ (دفتر/تنخواه) را انتخاب و دسته را ثبت کنید.",
    "«فایلِ پرداخت (اکسل)» را برای بانک بگیرید؛ شبا و کارت را با کلیک کپی کنید.",
    "بعد از واریز «همه پرداخت شد» یا «پرداخت شد» تک‌به‌تک.",
  ],
  faq: [["ردیفِ پرداخت‌شده حذف نمی‌شود", "اول «برگرداندن»ش را بزنید، بعد حذف یا ویرایش کنید."]],
});
add({
  id: "fin-txns", group: "accounting", title: "اسناد مالی (هزینه‌ها و تراکنش‌ها)", paths: ["/finance?tab=txns", "/finance"], imgs: ["fin-txns", "fin-voucher"],
  summary: "همهٔ اسنادِ مالیِ همهٔ پرسنل در یک لیست با شمارهٔ سند و «مانده تا این سند». سندِ تازه با «سند پرداخت / دریافت» زده می‌شود: پرداخت به شخص، دریافت از شخص، یا «قلمِ حقوقی».",
  steps: [
    "«سند پرداخت / دریافت» را بزنید و نوع را انتخاب کنید:",
    "پرداخت به شخص (مساعده، حواله، چک، پرداخت حقوق) ← حسابش بدهکار؛ مبدأ و روش را بزنید.",
    "دریافت از شخص (بازپرداختِ بدهی، برگشت وجه) ← حسابش بستانکار.",
    "قلمِ حقوقی: «اضافه‌کار ساعتی (ساعت × نرخ)»، «کارکردِ روزمزد»، «کارِ کارمزدی (تعداد × فی)»، «اضافه/کسر در حقوقِ ماه» ← ماه را انتخاب کنید؛ مستقیم در «محاسبه و بستن حقوق»ِ همان ماه می‌نشیند و حقوقِ آن نفر خودکار حساب می‌شود. جریمه، بوفه، خرید محصول و … هم همین‌جاست.",
    "شخص، مبلغ و تاریخ را بزنید؛ جعبهٔ سبز/زرد پایین می‌گوید حساب چطور عوض می‌شود. «ثبت سند».",
  ],
  fields: [
    ["نوع", "دقیقاً چه سندی است — مثلاً «پرداختِ حقوقِ شهریور — بیمه». فیلتر روی دسته."],
    ["ثبت از", "سند از کجا آمده: «✍ سندِ دستی»، «پرداخت حقوق»، «محاسبه و بستن حقوق»، «انتقال بین پرسنل»، «بستنِ حقوق (خودکار)»…"],
    ["مانده تا این سند", "حسابِ همان شخص با احتسابِ همین سند (به ترتیبِ تاریخ)."],
    ["وضعیت", "در انتظارِ پرداخت / پرداخت‌شده / «در حقوقِ … (ماه هنوز بسته نشده)» برای قلم‌های محاسبهٔ حقوق."],
  ],
  faq: [
    ["دکمهٔ ویرایش مرا جای دیگری می‌برد", "هر سند همان‌جا که ثبت شده ویرایش می‌شود: پرداختِ «پرداخت حقوق» ← همان تب و همان پرداخت؛ قلمِ «محاسبه و بستن حقوق» ← ویرایشگرِ همان نفر؛ سندِ دستی ← همین پنجره."],
    ["سندِ تکراری زده‌ام", "در ستونِ «ثبت از» سندِ «✍ سندِ دستی» را پیدا و حذف کنید."],
    ["قلمِ حقوقی برای ماهِ بسته ثبت نمی‌شود", "ماهِ بسته قلمِ جدید نمی‌گیرد؛ برای ماهِ باز ثبت کنید."],
    ["قلمِ «محاسبه و بستن حقوق» در صورتحساب نیست", "تا ماه بسته نشده فقط در اسنادِ مالی دیده می‌شود؛ با بستنِ ماه داخلِ «طلبِ حقوقِ» همان ماه در حساب می‌نشیند."],
  ],
});
add({
  id: "fin-petty", group: "accounting", title: "تنخواه (صندوق)", paths: ["/finance?tab=petty"], imgs: ["fin-petty"],
  summary: "موجودیِ صندوق = ماندهٔ اول + شارژها − هزینه‌ها. پرداخت/دریافتی که در اسناد، مساعده یا پرداخت حقوق با مبدأِ تنخواه ثبت شود خودش اینجا می‌نشیند.",
  steps: [
    "اولین بار «صندوقِ جدید» (نام، نگه‌دارنده، ماندهٔ اول دوره).",
    "«ثبتِ حرکت»: شارژ (به صندوق) یا هزینه (از صندوق) با مبلغ، تاریخ، طرف و شرح.",
    "آخرِ هر دوره «تطبیق موجودی»: شمارشِ واقعی را بزنید تا مغایرت سند شود.",
  ],
  faq: [["حرکتِ «از دفتر مالی» را اینجا ویرایش نمی‌کند", "از همان بخشی که ثبت شده (اسناد/مساعده/پرداخت حقوق) اصلاحش کنید."]],
});
add({
  id: "fin-ledger", group: "accounting", title: "دفتر حساب شخص (صورتحساب)", paths: ["/finance?tab=ledger"], imgs: ["fin-ledger"],
  summary: "ریزِ همهٔ اسنادِ یک نفر با ماندهٔ تجمعی — جواب به «الان چقدر حسابم است؟». این فیشِ حقوق نیست؛ ماندهٔ همین لحظه است.",
  steps: [
    "شخص را انتخاب کنید (یا در «مانده و وضعیت حساب» روی نامش بزنید).",
    "در صورتِ نیاز «از تاریخ / تا تاریخ».",
    "«صورتحساب PDF» برای چاپ یا ارسال؛ A4 یا A5 در پیش‌نمایش.",
    "روی شمارهٔ هر سند بزنید تا همان سند برای بررسی/ویرایش باز شود.",
  ],
});
add({
  id: "fin-reports", group: "accounting", title: "گزارش‌های مالی", paths: ["/finance?tab=reports", "/reports"], imgs: ["fin-reports"],
  summary: "گزارش‌های دوره یک‌جا: بدهکاران، پرداختِ حقوقِ دوره (با بانک و شبا)، خروجیِ تولید — همه با خروجیِ اکسل.",
  steps: ["دوره را انتخاب کنید.", "گزارش را باز کنید و «اکسل» بگیرید."],
});

/* ───────────────────────────── زنجیره تأمین ───────────────────────────── */
add({
  id: "sc-dashboard", group: "supply", title: "داشبورد زنجیره تأمین", paths: ["/supply-chain"], imgs: ["sc-dashboard"],
  summary: "مسیرِ کالا: خرید نخ (درین‌ریس) ← بافندگی (نوربخش/خوشباف) ← رنگرزی (پوشان) ← انبار قرچک. داشبورد موجودیِ هر انبار، ماندهٔ امانیِ هر طرف (نخ/پارچه‌ای که نزدِ بافنده یا رنگرز است)، ارزشِ کالا و «فی تمام‌شده» را نشان می‌دهد.",
  steps: [
    "بازه و «تأییدشده یا همه؟» را انتخاب کنید (پیش‌نویس‌ها فقط در «همه» شمرده می‌شوند).",
    "کارت‌های «دفترِ بافنده ›»، «دفترِ پوشان ›» و «موجودیِ تفکیکیِ انبار قرچک ›» جزئیات را باز می‌کنند.",
    "«ثبت حرکت جدید» شما را به ثبتِ فاکتور می‌برد.",
    "«تنظیماتِ تلورانس» درصدِ ضایعاتِ مجازِ هر مرحله را تعیین می‌کند.",
  ],
  faq: [["«ماندهٔ منفی» یعنی چه؟", "خروجیِ یک طرف بیشتر از ورودیِ ثبت‌شده‌اش است — معمولاً «مانده اول دوره» یا یک فاکتورِ ورودی ثبت نشده."]],
});
add({
  id: "sc-new", group: "supply", title: "ثبت فاکتور (خرید نخ / بافندگی / رنگرزی)", paths: ["/supply-chain/new"], imgs: ["sc-new"],
  summary: "هر حرکتِ کالا یک فاکتور است: خرید نخ (از تأمین‌کننده به بافنده)، خروجی بافندگی (پارچهٔ خام به رنگرزی)، خروجی رنگرزی (پارچهٔ رنگ‌شده به انبار قرچک).",
  steps: [
    "از منو «ثبت فاکتور ← خرید نخ / بافندگی / رنگرزی» را انتخاب کنید.",
    "«ثبت سریع» برای فیلدهای اصلی یا «ثبت کامل» برای همهٔ جزئیات.",
    "طرف‌حساب، تاریخ، نوع کالا/پارچه، رنگ، وزن (کیلو)، طاقه/کارتن و «شماره‌ها و توضیحات» (شماره فاکتور، سند، مجوز).",
    "«اطلاعات مالی» (فی و مبلغ) اختیاری است.",
    "«ثبت پیش‌نویس»؛ بعد در «فاکتورها» با «تأیید و ثبت در دفتر امانی» نهایی کنید.",
    "اگر فایلِ شرکت را دارید «ایمپورت فایل» را بزنید.",
  ],
  faq: [["وسطِ کار باید بروم", "«ذخیره پیش‌نویس محلی»؛ دفعهٔ بعد «ادامه پیش‌نویس این دسته» را بزنید."]],
});
add({
  id: "sc-import", group: "supply", title: "ایمپورت فایل", paths: ["/supply-chain/import"], imgs: ["sc-import"],
  summary: "فایلِ اکسل/CSV/PDFِ هر شرکت (قالبِ درین‌ریس، نوربخش، پوشان یا فایلِ «همگانی») خوانده و به فاکتورِ پیش‌نویس تبدیل می‌شود.",
  steps: [
    "تبِ «آپلود فایل»: نوع (همگانی، خرید نخ، بافندگی، رنگرزی) را انتخاب و فایل را بدهید. برای قالبِ خالی «دانلودِ فایلِ نمونهٔ این بخش».",
    "تبِ «پیش‌نمایش و اصلاح ردیف‌ها»: ردیف‌های «نیازمند بررسی» را تکمیل کنید.",
    "ردیف‌های تکراری (قبلاً ثبت‌شده) پیش‌فرض انتخاب نمی‌شوند؛ اگر واقعاً لازم است «ثبتِ مجدد».",
    "تأیید کنید؛ فاکتورهای پیش‌نویس ساخته می‌شوند و باید در «فاکتورها» تأییدِ نهایی شوند.",
  ],
  faq: [["ایمپورت مستقیم در دفتر می‌نشیند؟", "خیر؛ فقط پیش‌نویس می‌سازد."]],
});
add({
  id: "sc-events", group: "supply", title: "فاکتورها", paths: ["/supply-chain/events"], imgs: ["sc-events"],
  summary: "همهٔ فاکتورهای زنجیره با وضعیت: پیش‌نویس، تأییدشده، نیازمند تکمیل، نیازمند بررسی، مغایر.",
  steps: [
    "با فیلترِ دسته/وضعیت/تاریخ فاکتور را پیدا کنید و «مشاهده» بزنید.",
    "در صفحهٔ فاکتور «ویرایش»، «ذخیره و بعدی» (Alt+← و Alt+→ بینِ فاکتورها)، یا «تأیید و ثبت در دفتر امانی».",
    "فاکتورِ اشتباه را «لغو / ابطال» کنید (به «فاکتورهای لغوشده» می‌رود).",
    "«خروجی سفارشی» و «خروجی برای ایمپورت» اکسل می‌دهند.",
  ],
});
add({
  id: "sc-parties", group: "supply", title: "طرف‌حساب‌ها و شرکت‌ها", paths: ["/supply-chain/parties"], imgs: ["sc-parties"],
  summary: "فهرستِ تأمین‌کننده‌ها، بافنده‌ها، رنگرزها و انبارها با نقشِ هرکدام.",
  steps: ["«شرکتِ جدید» ← نام، نقش (تأمین‌کننده / کارگاه بافندگی / رنگرزی / انبار داخلی) و توضیح ← «ثبت»."],
});
add({
  id: "sc-freight", group: "supply", title: "حمل و بارنامه", paths: ["/supply-chain/freight"], imgs: ["sc-freight"],
  summary: "کرایه‌های حمل جدا ثبت می‌شوند و در فیِ پارت نمی‌آیند؛ فقط «هزینه با ما»هایی که در فیِ فروشنده لحاظ نشده، به‌صورتِ انتخابی در «فی تمام‌شده» جمع می‌شوند.",
  steps: ["«ثبت حمل جدید»: تاریخ، مبدأ، مقصد، بارنامه، راننده، وزن، کرایه، هزینه با (ما / تأمین‌کننده / سایر) و فاکتورِ مرتبط."],
});
add({
  id: "sc-scale", group: "supply", title: "اختلاف باسکولی", paths: ["/supply-chain/scale-discrepancy"], imgs: ["sc-scale"],
  summary: "مقایسهٔ وزنِ خروجیِ بافندگی با وزنِ ورودیِ اعلامیِ پوشان — فقط برای دانستنِ اختلاف؛ در موجودی و حساب‌ها وارد نمی‌شود.",
  steps: ["«آپلودِ کاردکسِ پوشان (PDF)» یا «از دادهٔ سیستم» یا «افزودنِ دستی».", "جدول اختلافِ هر رسید و میانگین را نشان می‌دهد."],
});
add({
  id: "sc-batches", group: "supply", title: "ردیابی (بچ)", paths: ["/supply-chain/batches"], imgs: ["sc-batches"],
  summary: "هر بچ (پارتِ کالا) را در طولِ زنجیره دنبال کنید: مرحله، نزدِ چه کسی، وزنِ فعلی و تایم‌لاینِ رویدادها.",
  steps: ["«بچ جدید» برای پارتِ تازه؛ روی هر بچ «تایم‌لاین» را بزنید."],
});
add({
  id: "sc-custody", group: "supply", title: "دفتر امانی", paths: ["/supply-chain/custody"], imgs: ["sc-custody"],
  summary: "ماندهٔ کالای ما نزدِ هر طرف (بافنده/رنگرز): دریافت‌شده − ارسال‌شده ± اصلاحیه. با تأییدِ هر فاکتور خودکار به‌روز می‌شود.",
});
add({
  id: "sc-opening", group: "supply", title: "مانده اول دوره", paths: ["/supply-chain/opening-balance"], imgs: ["sc-opening"],
  summary: "موجودیِ شروعِ سالِ هر طرف (کیلو). حسابِ سالِ هر طرف از این عدد شروع می‌شود.",
  steps: ["برای هر طرف/کالا «مانده اول دوره (kg)» را بزنید.", "طرف‌هایی که «ماندهٔ منفی» دارند معمولاً مانده اول دوره ندارند — همین‌جا تکمیل کنید."],
});
add({
  id: "sc-cancelled", group: "supply", title: "فاکتورهای لغوشده", paths: ["/supply-chain/cancelled"], imgs: ["sc-cancelled"],
  summary: "فاکتورهایی که لغو شده‌اند؛ در جمع‌ها و گزارش‌ها شمرده نمی‌شوند.",
  steps: ["«بازگردانی» = برگشت به فهرست به‌صورتِ پیش‌نویس (باید دوباره تأیید شود).", "«حذفِ انتخاب‌شده‌ها» برگشت‌پذیر نیست."],
});
add({
  id: "sc-reports", group: "supply", title: "گزارش‌های زنجیره", paths: ["/supply-chain/reports"], imgs: ["sc-reports"],
  summary: "فی تمام‌شده، موجودی انبار قرچک، ماندهٔ امانیِ هر طرف، ماهانه، داشبوردِ ضایعات، واریانسِ ضایعاتِ بافت و صفِ بررسی (فاکتورهای مغایر/بدونِ سند/بدونِ بچ).",
});

/* ───────────────────────────── گفتگو و مدیریت ───────────────────────────── */
add({
  id: "chat", group: "other", title: "گفتگو و یادداشت‌ها", paths: ["/chat"], imgs: ["chat"],
  summary: "پیام‌رسانِ داخلی، «یادداشت‌های مدیریتی» و «دفترچهٔ من». درخواست‌های تأیید (مثلاً اصلاحِ حضور در ماهِ نهایی‌شده) هم اینجا به مدیر می‌رسد.",
  steps: ["«گفت‌وگوی جدید» ← مخاطب ← پیام ← «ارسال».", "تبِ «یادداشت‌ها» برای یادداشتِ مدیریتی یا شخصی."],
});
add({
  id: "control-center", group: "other", title: "مرکز کنترل (فقط ادمینِ اصلی)", paths: ["/control-center"], imgs: ["control-center"],
  summary: "رفتارِ لحظه‌ایِ کاربران (کجا هستند، چه دکمه‌ای زدند، چه ثبت/ویرایشی کردند) با نمودار، و وضعیتِ سرور: CPU، RAM، دیسک، دیتابیس. هر ۵ ثانیه تازه می‌شود.",
  steps: ["روی کارتِ هر کاربر بزنید تا همه‌چیز فقط برای او فیلتر شود.", "بازهٔ نمودار: ۶ ساعت / ۲۴ ساعت / ۷ روز.", "در «جریانِ لحظه‌ای» صفحه/کلیک/ثبت را فیلتر کنید."],
  faq: [["مقدارِ فیلدها (مبلغ، رمز) هم ثبت می‌شود؟", "خیر؛ فقط نامِ دکمه/تب/صفحه."]],
});

/* ───────────────────────────── تنظیمات ───────────────────────────── */
add({
  id: "settings-work", group: "settings", title: "تنظیمات: ساعت کاری", paths: ["/settings?tab=work", "/settings"], imgs: ["settings-work"],
  summary: "پنجرهٔ حضورِ هر روزِ هفته (شروع/پایان/موظفی) — مبنای کسرکار و اضافه‌کاری.",
  fields: [["یک روز کامل", "برای روزهای کوتاه مثل پنجشنبه تا حضورِ کامل = ۱ روز حساب شود."], ["دقایقِ پرداختیِ یک روز", "مبنای نرخِ کسرکار/اضافه‌کاری (۴۲۰ دقیقه = ۷ ساعت)؛ با ساعتِ حضورِ واقعی فرق دارد."]],
});
add({
  id: "settings-holidays", group: "settings", title: "تنظیمات: تقویم تعطیلات و مرخصی", paths: ["/settings?tab=holidays", "/settings?tab=leaves"], imgs: ["settings-holidays", "settings-leaves"],
  summary: "تعطیلاتِ رسمی/کارخانه (باحقوق یا بی‌حقوق) و مرخصیِ هر نفر — در حضور و حقوق اثر دارند.",
  steps: ["تاریخ، نوع و مناسبت را بزنید و «افزودن».", "مرخصی: پرسنل، بازهٔ تاریخ، نوع (باحقوق/بی‌حقوق)."],
});
add({
  id: "settings-users", group: "settings", title: "تنظیمات: کاربران و دسترسی‌ها", paths: ["/settings?tab=users"], imgs: ["settings-users"],
  summary: "هر کاربر: نام کاربری، رمزِ ورود، «کدِ مدیریتی» (برای عملیاتِ حساس)، نقش، مجوزهای دقیق و «مدتِ نشست».",
  steps: [
    "«کاربر جدید»: نام کاربری، نام، نقش و رمز.",
    "مجوزها: یا «پیروی از نقش» یا تیک‌های دقیق (مشاهده/ثبت/ویرایش/حذف/خروجی/دیدنِ مبالغ برای هر بخش).",
    "«کدِ مدیریتی» فقط برای کسی که باید قفل‌ها را باز کند.",
    "«مدتِ نشست»: مثلاً ۱۲ ساعت ⇒ هر ۱۲ ساعت ورودِ اجباری (از همان لحظه روی همهٔ دستگاه‌هایش).",
  ],
  faq: [["رمزم را فراموش کرده‌ام", "مدیر در ویرایشِ کاربرِ شما رمزِ جدید می‌گذارد."], ["آخرین مدیر را نمی‌شود غیرفعال کرد", "برای جلوگیری از قفل‌شدنِ سیستم."]],
});
add({
  id: "settings-payroll", group: "settings", title: "تنظیمات: حقوق، حسابداری و محصول/رنگ/سایز", paths: ["/settings?tab=payroll", "/settings?tab=accounting", "/settings?tab=production-options"], imgs: ["settings-payroll"],
  summary: "پارامترهای محاسبهٔ حقوق، قواعدِ حسابداری، و فهرستِ محصولات/رنگ‌ها/سایزهای فرمِ برش.",
});
add({
  id: "settings-backup", group: "settings", title: "تنظیمات: بکاپ و بازیابی", paths: ["/settings?tab=backup", "/settings?tab=restore"], imgs: ["settings-backup", "settings-restore"],
  summary: "بکاپِ دیتابیس و فایل‌ها: خودکار (روزانه/هفتگی) با ارسال به ایمیل و تلگرام، یا «ساختِ بکاپ الان». بازیابی قبل از هر کار یک بکاپِ ایمنی می‌گیرد و اگر شکست بخورد خودکار برمی‌گرداند.",
  steps: [
    "بکاپ: زمان‌بندی، تعدادِ نسخه/روزِ نگه‌داری، کانال‌ها (SMTP، تلگرام) ← «ذخیرهٔ تنظیمات».",
    "بازیابی: ۱) نسخه را انتخاب یا آپلود کنید ← دامنه (دیتابیس / فایل‌ها / کامل) ← حالت ← «تأیید و اجرا».",
  ],
  faq: [["بازیابیِ دیتابیس دادهٔ فعلی را پاک می‌کند؟", "بله، جایگزین می‌کند — برای همین قبلش بکاپِ ایمنی گرفته می‌شود."]],
});
add({
  id: "settings-update", group: "settings", title: "تنظیمات: بروزرسانی نرم‌افزار", paths: ["/settings?tab=update"], imgs: ["settings-update"],
  summary: "نصبِ نسخهٔ جدید از فایلِ ZIP یا لینک؛ فقط کد عوض می‌شود و داده‌ها می‌مانند. پیش از نصب بکاپِ خودکار و در صورتِ خطا برگشتِ خودکار.",
  steps: ["«آپلودِ فایلِ بروزرسانی» یا «دریافت از لینک» ← بررسیِ صحت ← «نصب با اجازهٔ کاربران» یا «نصبِ فوری»."],
  faq: [["«پینِ مدیریتی تنظیم نشده»", "از «کاربران» برای مدیرِ اصلی کدِ مدیریتی بگذارید."]],
});
add({
  id: "settings-activity", group: "settings", title: "تنظیمات: گزارش فعالیت و ظاهر", paths: ["/settings?tab=activity", "/settings?tab=appearance"], imgs: ["settings-activity", "settings-appearance"],
  summary: "«گزارش فعالیت»: چه کسی، چه کاری، چه زمانی (روی هر ردیف جزئیاتِ تغییر). «ظاهر»: رنگ‌بندی، تیره/روشن، تراکم، و بازگرداندنِ چیدمانِ جدول‌ها.",
});

/* ───────────────────────────── اموال ───────────────────────────── */
add({
  id: "assets", group: "assets", title: "اموال", paths: ["/assets"], perm: "assets.view",
  summary: "فهرستِ همهٔ اموالِ کارخانه — هم آنچه مالکش خودمان هستیم و هم آنچه امانی نزدِ ماست — با کد، سریال، تعداد، مبلغِ حدودی، تاریخِ خرید و ورود، محلِ نگهداری و تحویل‌گیرنده؛ با چاپِ لیست و لیبلِ بارکددار برای چسباندن روی هر قلم. این بخش دسترسیِ انحصاری دارد و فقط کسی که مدیر صریحاً تیکش را زده می‌بیند.",
  steps: [
    "«افزودنِ اموال» را بزنید؛ نام لازم است و کد اگر خالی بماند خودکار ساخته می‌شود (AM-0001، AM-0002، …).",
    "سریالِ خودِ دستگاه را تایپ کنید یا دکمهٔ «اسکن» کنارش را بزنید. بالای پنجرهٔ اسکن دو حالت هست: «متن (سریالِ چاپی)» — فقط خطِ سریال را داخلِ کادر بگیرید و «بخوان» را بزنید، بعد از دکمه‌های پیشنهادی درست را انتخاب کنید — یا «بارکد / QR» که خودکار می‌خواند. بعد «همین را بنشان». اگر دوربین باز نشد «عکس از لیبل» را بزنید.",
    "کدِ اموال (برچسبِ خودمان) هم دکمهٔ اسکن دارد؛ همان دو حالت.",
    "زیرِ سریال «عکس از سریال» را بزنید و از پلاکِ دستگاه عکس بگیرید (یا از گالری). حجمِ عکس خودکار کم می‌شود (حدودِ ۲۰۰ تا ۴۵۰ کیلوبایت) بدونِ اینکه متنِ سریال خراب شود؛ در جدول ستونِ «عکس» با آیکونِ دوربین بازش می‌کند.",
    "اگر کالا امانی است «مالکیت: امانی» را بزنید و نامِ مالک را بنویسید.",
    "برای ثبتِ پشتِ‌سرِهم (مثلاً روی گوشی در سالن) «ذخیره و بعدی» را بزنید: فرم برای قلمِ بعدی باز می‌ماند و محل، مالک و تاریخ‌ها حفظ می‌شوند.",
    "برای پیدا کردنِ یک قلم، «اسکن» بالای صفحه را بزنید و لیبلِ اموال (AM-…) یا سریالِ دستگاه را اسکن کنید؛ اگر پیدا شد فرمش باز می‌شود.",
    "برای تغییرِ چند ردیف با هم «ویرایش دسته‌جمعی» ← سلول‌ها را عوض کنید یا ردیف‌ها را تیک بزنید و «اعمال روی انتخاب‌شده‌ها» ← «ذخیره همه».",
    "ردیف‌ها را تیک بزنید (یا تیکِ سرستون برای همه) و از نوارِ بالا «چاپ لیبل»، «چاپ لیست» یا «اکسلِ انتخاب‌شده‌ها» را بزنید.",
  ],
  fields: [
    ["کد اموال", "شمارهٔ یکتای هر قلم که روی لیبل به‌صورتِ بارکد چاپ می‌شود؛ تکراری پذیرفته نمی‌شود."],
    ["سریال", "سریالِ سازنده (روی پلاکِ دستگاه)."],
    ["مبلغ حدودی", "قیمتِ تقریبیِ یک عدد به ریال؛ «جمع» = تعداد × مبلغ."],
    ["تاریخ ورود", "روزی که کالا (خریداری‌شده یا امانی) تحویلِ ما شد."],
    ["چاپ لیبل", "اندازهٔ لیبل (۵۰×۲۵، ۶۰×۴۰، ۸۰×۵۰ میلی‌متر یا برگهٔ A4) و اطلاعاتِ روی لیبل را انتخاب کنید؛ برای هر قلم یک لیبل (یا به تعدادِ هر قلم)."],
  ],
  faq: [
    ["مدیر هم این بخش را نمی‌بیند؟", "درست است؛ دسترسیِ اموال در هیچ نقشی نیست. در «تنظیمات ← کاربران ← ویرایش» بخشِ «دسترسیِ انحصاری» را برای همان نفر تیک بزنید."],
    ["دوربین باز نمی‌شود", "اجازهٔ دوربین را در مرورگرِ گوشی برای این سایت روشن کنید (آیکونِ قفل کنارِ آدرس). در مرورگرِ داخلیِ تلگرام/واتساپ دوربین کار نمی‌کند؛ سایت را در کروم یا سافاری باز کنید، یا «عکس از لیبل» را بزنید."],
    ["سریال فقط نوشته است و بارکد ندارد", "حالتِ «متن» را بزنید. بهترین نتیجه: نزدیک، صاف، با نورِ کافی (چراغ‌قوه) و فقط خطِ سریال داخلِ کادر. حروفِ شبیه (O و 0، I و 1، S و 5) را قبل از «همین را بنشان» چک کنید. متنِ دست‌نویس یا فارسی خوانده نمی‌شود."],
    ["بارِ اولِ اسکنِ متن کند است", "بارِ اول موتورِ خواندنِ متن (~۷ مگابایت) از سرورِ خودمان دانلود می‌شود؛ بعد از آن مرورگر نگهش می‌دارد و سریع است."],
    ["چاپگرِ لیبل اندازهٔ دیگری دارد", "در پنجرهٔ چاپ، «Margins: None» و اندازهٔ کاغذِ چاپگر را بگذارید؛ اگر اندازه در فهرست نیست، نزدیک‌ترین را انتخاب کنید."],
  ],
});

/* ───────────────────────────── پیگیری رنگرزی ───────────────────────────── */
add({
  id: "dye", group: "dye", title: "پیگیری رنگرزی", paths: ["/dye"], perm: "dye.view",
  summary: "پیگیریِ پارچهٔ خامِ بافته‌شده که وارد رنگرزی می‌شود و رنگ‌هایی که از آن سفارش می‌شود — همه به طاقه. هر «پارت» یعنی یک بار ورودِ پارچهٔ خام به رنگرزی در یک تاریخ (برچسبش روز-ماهِ ورود است، مثلِ ۳۱-۸). بالای صفحه همیشه سه عدد هست: خامِ بی‌سفارش، در رنگرزی و تحویل‌شده. این بخش دسترسیِ انحصاری دارد.",
  steps: [
    "«پارتِ تازه» را بزنید: تاریخِ ورود و تعدادِ طاقه لازم است؛ نخ، دهانه، عرضِ درخواستی، رنگرزی و کدِ رهگیریِ رنگرزی اختیاری‌اند و هر وقت خواستید بعداً هم پر می‌شوند.",
    "روی هر کادر که بزنید، گزینه‌های قبلی باز می‌شود و همان لحظه می‌شود تایپ کرد؛ برای نخ و دهانه دکمه‌های سریع هم زیرِ کادر هست. هر مقدارِ تازه‌ای که تایپ کنید دفعهٔ بعد پیشنهاد می‌شود.",
    "برای ثبتِ پشتِ‌سرِهم «ثبت و پارتِ بعدی» را بزنید: تاریخ، نخ، دهانه و رنگرزی می‌ماند و فقط طاقه و کدِ رهگیری را از نو می‌زنید.",
    "افزودنِ رنگ از داخلِ پارت: در پنجرهٔ پارت «افزودنِ رنگ به این پارت» را بزنید، رنگ‌ها و تعداد را بنویسید؛ به سفارشِ تحویل‌نشدهٔ همان پارت اضافه می‌شود یا سفارشِ تازه می‌سازد.",
    "سفارشِ رنگ: از روی پارت «سفارشِ رنگ از این پارت» یا بالای صفحه «سفارشِ رنگ». پارت(ها) را انتخاب کنید و برای هر رنگ نام، کد (اختیاری) و طاقه بنویسید. پایینِ فرم ماندهٔ پارت‌ها، سفارش و باقی را می‌بینید؛ سهمِ هر پارت خودکار از قدیمی‌ترین پارت برداشته می‌شود.",
    "شمارهٔ سفارش خودکار از تاریخِ پارت ساخته می‌شود (مثلاً ۱-۸؛ سفارشِ دومِ همان پارت «۱-۸ (۲)») و در ویرایش قابلِ تغییر است. حملِ تا قرچک (راننده، کرایه، پرداخت شد) اختیاری است.",
    "بعد از ثبت، «فایل PDF سفارش» ← «ارسال» را بزنید تا PDF در واتس‌اپ/تلگرام/… فرستاده شود (روی کامپیوتر دانلود می‌شود). در PDF برای هر پارت کل، این سفارش، سفارش‌های دیگر، منتقل‌شده و مانده آمده است.",
    "مانده به پارتِ دیگری رفت؟ در پارت «انتقالِ مانده» را بزنید و پارتِ مقصد و تعداد را بدهید؛ از ماندهٔ این پارت کم و به آن پارت اضافه می‌شود.",
    "دو پارت با هم یکی شدند (تاریخ و حجمِ جدا، کدِ رهگیریِ مشترک)؟ «ادغام با پارت» را بزنید؛ کدِ رهگیریِ هر دو یکی می‌شود و جدولِ گروه (ورود، سفارش، مانده) را می‌بینید و در هر پارت لینکِ پارتِ دیگر را می‌بینید که با یک لمس بینشان جابه‌جا شوید.",
    "تحویل: در سفارش کنارِ هر رنگ تعدادِ تحویل‌شده را بزنید (یا «همه»)، یا «تحویلِ کامل» برای کلِ سفارش؛ در پارت «تحویلِ کاملِ پارت» همهٔ سفارش‌هایش را با هم تحویل می‌زند. تبِ «تحویل‌شده» جمعِ هر رنگ و کد را نشان می‌دهد.",
    "هر نخ جدا رنگ می‌شود: انتقال، ادغام و سفارشِ چندپارتی فقط بینِ پارت‌های هم‌نخ ممکن است و تبِ «مانده» مانده را به تفکیکِ نخ نشان می‌دهد.",
    "موجودیِ اولِ دوره: چرخ‌دنده ← «موجودیِ اولِ دوره». طاقهٔ خامِ هر نخ که قبل از شروع در رنگرزی بوده؛ پارت نیست، در «مانده» کنارِ همان نخ و در سفارش با نامِ «اول دوره» می‌آید.",
    "فهرستِ پارت‌ها به ترتیبِ مرحله است: خام ← در رنگرزی ← تحویل‌شده؛ فیلترِ بالای فهرست (همه/خام/در رنگرزی/تحویل‌شده) و تبِ آخر یادش می‌ماند.",
    "دکمهٔ چرخ‌دنده (بالای صفحه): گزینه‌های پیش‌فرضِ نخ، دهانه، عرض، رنگرزی، رنگ (با کد) و راننده — افزودن، تغییرِ نام، ترتیب، پنهان‌کردن و حذف.",
  ],
  fields: [
    ["مانده", "طاقهٔ پارت + انتقالیِ آمده − منتقل‌شده − سفارش‌ها. منفی (قرمز) یعنی بیشتر از ورود سفارش داده شده — پارت یا سفارش را بررسی کنید."],
        ["کد رهگیری", "کدی که خودِ رنگرزی می‌دهد (ممکن است دیرتر برسد)؛ پارت‌های با کدِ رهگیریِ یکسان «ادغام‌شده» حساب می‌شوند."],
  ],
  faq: [
    ["مدیر هم این بخش را نمی‌بیند؟", "درست است؛ مثلِ اموال در هیچ نقشی نیست. در «تنظیمات ← کاربران ← ویرایش» بخشِ «دسترسیِ انحصاری ← پیگیری رنگرزی» را تیک بزنید."],
    ["کاربری که فقط همین بخش را ببیند", "نقشش را «فقط بخشِ اختصاصی» بگذارید و پیگیری رنگرزی را تیک بزنید؛ بعد از ورود مستقیم همین صفحه باز می‌شود و منوی دیگری نمی‌بیند. برای هر کاربر «صفحهٔ اول بعد از ورود» را هم در همان فرم می‌شود انتخاب کرد."],
    ["دکمهٔ «ارسال» نیست، فقط «دانلود» است", "مرورگرِ کامپیوتر یا مرورگرِ داخلیِ تلگرام اشتراکِ فایل ندارد؛ سایت را در کروم/سافاریِ گوشی باز کنید."],
  ],
});

/** راهنمای صفحهٔ فعلی: بهترین تطبیقِ مسیر (+ ?tab=). */
export function guideFor(pathname, search = "") {
  const qs = new URLSearchParams(search || "");
  const tab = qs.get("tab");
  let best = null; let score = -1;
  for (const g of G) {
    for (const p of g.paths || []) {
      const [pp, pq] = p.split("?");
      const ptab = pq ? new URLSearchParams(pq).get("tab") : null;
      const pathOk = pathname === pp || (pp !== "/" && pathname.startsWith(pp + "/"));
      if (!pathOk) continue;
      if (ptab && ptab !== tab) continue;
      const sc = pp.length * 2 + (ptab ? 1 : 0);
      if (sc > score) { score = sc; best = g; }
    }
  }
  return best;
}

export const GUIDES = G;
